// utils/downloadFile.js
export const downloadFile = async (url, filename) => {
  try {
    const response = await fetch(url, { method: "GET" });
    if (!response.ok) throw new Error("Failed to download file");

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename; // force filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download error:", error);
    alert("Failed to download file.");
  }
};
